<template>
  <section>
    <div >
      <div v-if="date !== ''">
        <h1>
          <span>{{text}}</span>
          <span class="date">{{ date }}</span>
        </h1>
        <Button  v-if="cancelable" @click="cancelAppointment" text='Cancel your appointment' link="" />
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import Footer from "@/components/Footer";
import Button from "@/components/Button";
export default {
  name: "Home",
  components: {
    Button,
    Footer,
  },
  created() {
    const params = new URLSearchParams();
    params.append('purl', this.$route.params.purl);
    axios.post(`${this.$store.state.API}/CancelPurl.php`, params).then(this.onGetPurl);
  },
  data() {
    return {
    text:"Your Appointment is scheduled for",
      date: "",
      cancelable:false,
      cancelled:false,
    };
  },
  methods: {
      cancelAppointment() {
        this.cancelable = false;
        const params = new URLSearchParams();
        params.append('method', 'cancel');
        params.append('id', this.$route.params.purl);
        axios.post(`${this.$store.state.API}/CancelAppointment.php`, params).then(this.onCancelAppointment);       
      },
      onCancelAppointment(response){
        if(response.data.status == 'ok') {
             alert('Your appointment has been cancelled.');
            this.cancelled = true;
            this.text = "Your cancelled appointment was on"
        }
      },
      onGetPurl(response){
          if(response.data.status == 'ok') {
            this.date = response.data.appointment;
            this.cancelable = true;
          }
      }
  }
};
</script>

<style lang="scss" scoped>
.logo {  
  max-width: 90vw;
  object-fit: contain;
}
h1 {
  color: var(--white);
  text-transform: uppercase;
  span {
    font-size: 0.875rem;
    display: block;
    &.date {
      margin-top:20px;
      font-size: 2.5rem;
    }
  }
}

section {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  > div {
    flex-grow: 1;
    display: grid;
    align-items: end;
    background-image: url("~@/assets/images/welcome.jpg");
    background-size: cover;
    background-position: center;
    padding: 25px 0;
    grid-template-rows: 1fr 1fr;
  }
}
</style>
